//
// hide the co-borrower address fields when the checkbox is checked
//
var coborrowerAddressHide = (function () {
    'use strict';

    var containerSelector = ".co_borrower_address_container";
    var checkboxSelector = "input[name^='co_borrower_same_address']";
    var templateSelector = "#co-borrower-form-template";
    var clone = "";

    // this copy of the form section outside the form in a hidden div is needed because we can't simply hide() the elements due to the validations preventing us from continuing to the next step
    function init() {
        $(checkboxSelector).on("change", function (e) {
            var parent = $(this).parents("div[data-sf-role='separator']");
            var container = parent.find(containerSelector);
            var checked = $("form").find(this).prop("checked");
            if (checked) {
                // make a copy of the initial form section
                clone = container.children().first().detach();
                $(templateSelector).append(clone);

                // remove the section from the form
                $("form").find(container).children().remove();
            } else {
                // make a copy of the initial form section
                clone = $(templateSelector).children().first().detach();
                container.append(clone);

                // remove the section from the form
                $(templateSelector).children().remove();
            }
        });
    }

    if ($(checkboxSelector).length) {
        init();
    }
})();
